import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from "rxjs";
//import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class LoadingScreenService {

  private _loading: boolean = true;
  loadingStatus: Subject<any> = new Subject();
  //public loadingStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  status: any;

  get loading():boolean {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
    this.loadingStatus.next(value);
  }
  display(value: boolean) {
    this.loadingStatus.next(value);
  }
  startLoading() {
    this._loading = true;
  }

  stopLoading() {
    this._loading = false;
  }
}
